/* ─────────────────────────────────────────
   FORTA COSMETICS — SHOPIFY THEME JS
   Handles: cart AJAX, header scroll, mobile menu,
   product gallery, variant selection, accordion,
   waitlist form (Klaviyo)
───────────────────────────────────────── */

// ══════════════════════════════════════
// CART — AJAX API
// ══════════════════════════════════════
let _cartData = null;

async function fetchCart() {
  try {
    const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    _cartData = await res.json();
    renderCartDrawer(_cartData);
    updateCartCount(_cartData.item_count);
  } catch (e) {
    console.error('[Forta] fetchCart error:', e);
  }
}

async function addToCart(variantId, quantity = 1) {
  const btn = document.querySelector('[data-atc-btn]');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity }),
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await fetchCart();
    openCartDrawer();
    if (btn) {
      btn.textContent = '(Added to Bag)';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalLabel || '(Add to Bag)';
      }, 3000);
    }
  } catch (e) {
    console.error('[Forta] addToCart error:', e);
    if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalLabel || '(Add to Bag)'; }
  }
}

async function changeCartItem(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await fetchCart();
  } catch (e) {
    console.error('[Forta] changeCartItem error:', e);
  }
}

function formatMoney(cents) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = count > 0 ? `CART (${count})` : 'CART';
  });
  document.querySelectorAll('[data-cart-count-num]').forEach((el) => {
    el.textContent = count;
  });
}

function renderCartDrawer(cart) {
  const itemsEl = document.getElementById('cart-drawer-items');
  const footerEl = document.getElementById('cart-drawer-footer');
  const titleEl = document.getElementById('cart-drawer-title');

  if (!itemsEl) return;

  if (titleEl) {
    titleEl.textContent = `Your Bag (${cart.item_count})`;
  }

  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><p>Your bag is empty</p></div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = '';

  itemsEl.innerHTML = cart.items.map((item) => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item__image">
        ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
      </div>
      <div class="cart-item__details">
        <div>
          <p class="cart-item__name">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <p class="cart-item__price">${formatMoney(item.price)}</p>
        </div>
        <div class="cart-item__controls">
          <div class="cart-qty">
            <button
              class="cart-qty__btn"
              onclick="changeCartItem('${item.key}', ${item.quantity - 1})"
              aria-label="Decrease quantity"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
            <span class="cart-qty__count">${item.quantity}</span>
            <button
              class="cart-qty__btn"
              onclick="changeCartItem('${item.key}', ${item.quantity + 1})"
              aria-label="Increase quantity"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
          </div>
          <button
            class="cart-remove-btn"
            onclick="changeCartItem('${item.key}', 0)"
            aria-label="Remove item"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
          </button>
        </div>
      </div>
    </div>
  `).join('');

  // Footer
  const subtotal = formatMoney(cart.total_price);
  footerEl.innerHTML = `
    <div class="cart-subtotal">
      <span class="cart-subtotal__label">Subtotal</span>
      <span class="cart-subtotal__amount">${subtotal}</span>
    </div>
    <a href="/checkout" class="cart-checkout-btn">(CHECKOUT)</a>
  `;
}

// ══════════════════════════════════════
// CART DRAWER — OPEN / CLOSE
// ══════════════════════════════════════
function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const backdrop = document.getElementById('cart-backdrop');
  if (drawer) drawer.classList.add('is-open');
  if (backdrop) backdrop.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const backdrop = document.getElementById('cart-backdrop');
  if (drawer) drawer.classList.remove('is-open');
  if (backdrop) backdrop.classList.remove('is-open');
  document.body.style.overflow = '';
}

// ══════════════════════════════════════
// HEADER — SCROLL BEHAVIOR
// ══════════════════════════════════════
function initHeader() {
  const header = document.getElementById('site-header');
  const mobileMenu = document.getElementById('mobile-menu');
  if (!header) return;

  const isTransparent = header.dataset.transparent === 'true';
  let lastScrollY = 0;
  let scrollVelocity = 0;
  let lastTime = Date.now();

  // Position mobile menu correctly
  function positionMobileMenu() {
    if (!mobileMenu) return;
    const hasBanner = document.body.classList.contains('has-banner');
    const bannerH = hasBanner ? 36 : 0;
    mobileMenu.style.top = `${bannerH + 56}px`;
  }
  positionMobileMenu();

  function handleScroll() {
    const currentY = window.scrollY;
    const now = Date.now();
    const dt = now - lastTime;
    const dy = lastScrollY - currentY;
    const vel = dt > 0 ? (dy / dt) * 1000 : 0;
    scrollVelocity = vel * 0.3 + scrollVelocity * 0.7;

    const threshold = isTransparent ? window.innerHeight * 0.75 : 64;
    const pastThreshold = currentY > threshold;

    if (isTransparent) {
      if (pastThreshold) {
        header.classList.remove('is-transparent');
        header.classList.add('is-scrolled');
      } else {
        header.classList.add('is-transparent');
        header.classList.remove('is-scrolled');
      }
    } else {
      if (pastThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    if (pastThreshold) {
      if (scrollVelocity > 600) {
        header.classList.remove('is-hidden');
      } else if (currentY > lastScrollY) {
        header.classList.add('is-hidden');
        closeMobileMenu();
      }
    } else {
      header.classList.remove('is-hidden');
    }

    lastScrollY = currentY;
    lastTime = now;
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Initial state
  if (isTransparent) {
    header.classList.add('is-transparent');
  }
}

// ══════════════════════════════════════
// MOBILE MENU
// ══════════════════════════════════════
function openMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const backdrop = document.getElementById('mobile-menu-backdrop');
  if (menu) menu.classList.add('is-open');
  if (backdrop) backdrop.classList.add('is-open');
}

function closeMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const backdrop = document.getElementById('mobile-menu-backdrop');
  if (menu) menu.classList.remove('is-open');
  if (backdrop) backdrop.classList.remove('is-open');
}

function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  if (!menu) return;
  if (menu.classList.contains('is-open')) {
    closeMobileMenu();
  } else {
    openMobileMenu();
  }
  // Update hamburger icon
  const openIcon = document.getElementById('menu-icon-open');
  const closeIcon = document.getElementById('menu-icon-close');
  if (openIcon && closeIcon) {
    const isOpen = menu.classList.contains('is-open');
    openIcon.style.display = isOpen ? 'none' : 'block';
    closeIcon.style.display = isOpen ? 'block' : 'none';
  }
}

// ══════════════════════════════════════
// HERO PARALLAX
// ══════════════════════════════════════
function initHeroParallax() {
  const parallax = document.getElementById('hero-parallax');
  if (!parallax) return;

  function update() {
    const scrollY = window.scrollY;
    parallax.style.transform = `translateY(${scrollY * 0.4}px)`;
  }

  window.addEventListener('scroll', update, { passive: true });
}

// ══════════════════════════════════════
// PRODUCT GALLERY
// ══════════════════════════════════════
function initProductGallery() {
  const gallery = document.getElementById('product-gallery');
  if (!gallery) return;

  const mainImg = document.getElementById('gallery-main-img');
  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');

  if (!mainImg || thumbs.length === 0) return;

  let currentIndex = 0;
  const images = Array.from(thumbs).map((t) => ({
    src: t.dataset.src,
    alt: t.dataset.alt || '',
  }));

  function goTo(idx) {
    currentIndex = idx;
    mainImg.src = images[idx].src;
    mainImg.alt = images[idx].alt;
    thumbs.forEach((t, i) => {
      t.classList.toggle('is-active', i === idx);
    });
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => goTo(i));
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const prev = (currentIndex - 1 + images.length) % images.length;
      goTo(prev);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const next = (currentIndex + 1) % images.length;
      goTo(next);
    });
  }

  // Init first thumb as active
  goTo(0);
}

// ══════════════════════════════════════
// VARIANT SELECTION
// ══════════════════════════════════════
function initVariantSelection() {
  const form = document.getElementById('product-form');
  if (!form) return;

  const variantsJson = document.getElementById('product-variants-json');
  if (!variantsJson) return;

  let variants;
  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (e) {
    return;
  }

  const variantInput = document.getElementById('variant-id-input');
  const priceEl = document.getElementById('product-price');
  const atcBtn = document.getElementById('atc-btn');

  // Group option buttons by option index
  const optionGroups = form.querySelectorAll('[data-option-group]');

  function getSelectedOptions() {
    const selected = {};
    optionGroups.forEach((group) => {
      const name = group.dataset.optionGroup;
      const activeBtn = group.querySelector('.variant-btn.is-active');
      if (activeBtn) selected[name] = activeBtn.dataset.optionValue;
    });
    return selected;
  }

  function findVariant(selectedOptions) {
    return variants.find((v) =>
      v.options.every((opt, i) => {
        const optionName = Object.keys(selectedOptions)[i];
        return selectedOptions[optionName] === opt;
      })
    );
  }

  function updateUI(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (atcBtn) {
      const available = variant.available;
      atcBtn.disabled = !available;
      atcBtn.className = `atc-btn ${available ? 'atc-btn--available' : 'atc-btn--unavailable'}`;
      const price = formatMoney(variant.price);
      atcBtn.dataset.originalLabel = available ? `(Add to Bag — ${price})` : 'Sold Out';
      atcBtn.textContent = atcBtn.dataset.originalLabel;
    }
  }

  optionGroups.forEach((group) => {
    const btns = group.querySelectorAll('.variant-btn');
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        btns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const selected = getSelectedOptions();
        const variant = findVariant(selected);
        if (variant) updateUI(variant);
      });
    });
  });

  // Init: mark first available variant selected
  if (variants.length > 0) {
    const firstAvailable = variants.find((v) => v.available) || variants[0];
    // Activate the matching option buttons
    optionGroups.forEach((group, i) => {
      const optVal = firstAvailable.options[i];
      const btns = group.querySelectorAll('.variant-btn');
      btns.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.optionValue === optVal);
      });
    });
    updateUI(firstAvailable);
  }
}

// ══════════════════════════════════════
// QUANTITY SELECTOR
// ══════════════════════════════════════
function initQuantitySelector() {
  const qtyCount = document.getElementById('qty-count');
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus = document.getElementById('qty-plus');
  const qtyInput = document.getElementById('qty-input');
  if (!qtyCount || !qtyMinus || !qtyPlus) return;

  let qty = 1;

  function update() {
    qtyCount.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
    qtyMinus.disabled = qty <= 1;
  }

  qtyMinus.addEventListener('click', () => { if (qty > 1) { qty--; update(); } });
  qtyPlus.addEventListener('click', () => { qty++; update(); });
  update();
}

// ══════════════════════════════════════
// ADD TO CART — PRODUCT PAGE
// ══════════════════════════════════════
function initProductForm() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const variantId = document.getElementById('variant-id-input')?.value;
    const qty = parseInt(document.getElementById('qty-input')?.value || '1', 10);
    if (!variantId) return;
    await addToCart(variantId, qty);
  });
}

// ══════════════════════════════════════
// ADD TO CART — HOME / SHOP CARDS
// ══════════════════════════════════════
function initQuickAddBtns() {
  document.querySelectorAll('[data-quick-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      const original = btn.textContent;
      btn.textContent = '...';
      await addToCart(variantId, 1);
      btn.disabled = false;
      btn.textContent = original;
    });
  });
}

// ══════════════════════════════════════
// ACCORDION
// ══════════════════════════════════════
function initAccordions() {
  document.querySelectorAll('[data-accordion]').forEach((accordion) => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    const content = accordion.querySelector('[data-accordion-content]');
    const icon = accordion.querySelector('[data-accordion-icon]');
    if (!trigger || !content) return;

    // Set initial max-height on open accordions
    if (content.classList.contains('is-open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    trigger.addEventListener('click', () => {
      const isOpen = content.classList.contains('is-open');
      if (isOpen) {
        content.classList.remove('is-open');
        content.style.maxHeight = '0';
        if (icon) icon.textContent = '+';
      } else {
        content.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        if (icon) icon.textContent = '−';
      }
    });
  });
}

// ══════════════════════════════════════
// WAITLIST FORM (KLAVIYO)
// ══════════════════════════════════════
function initWaitlistForm() {
  const form = document.getElementById('waitlist-form');
  if (!form) return;

  const input = form.querySelector('#waitlist-email');
  const btn = form.querySelector('#waitlist-submit');
  const successEl = document.getElementById('waitlist-success');

  const KLAVIYO_COMPANY_ID = 'TFm8wP'; // your public site ID
  const KLAVIYO_LIST_ID = 'WyMVzc';    // your target list
  const KLAVIYO_REVISION = '2026-04-15';

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = input?.value?.trim();
    if (!email) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address.');
      return;
    }

    const COOLDOWN = 60_000;
    const last = parseInt(localStorage.getItem('waitlist_last_submit') || '0', 10);
    if (Date.now() - last < COOLDOWN) {
      alert('Please wait a moment before submitting again.');
      return;
    }

    const originalText = btn?.textContent;
    if (btn) {
      btn.disabled = true;
      btn.textContent = '...';
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': KLAVIYO_REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED'
                          }
                        }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: KLAVIYO_LIST_ID
                  }
                }
              }
            }
          })
        }
      );

      if (!response.ok) {
        let message = 'Please try again.';
        try {
          const errData = await response.json();
          message = errData?.errors?.[0]?.detail || errData?.message || message;
        } catch (_) {}
        throw new Error(message);
      }

      localStorage.setItem('waitlist_last_submit', Date.now().toString());

      form.style.display = 'none';
      if (successEl) successEl.style.display = 'inline-block';

      if (window.klaviyo?.identify) {
        window.klaviyo.identify({ email });
      }
    } catch (err) {
      alert(`Something went wrong: ${err.message || 'Please try again.'}`);
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  });
}

// ══════════════════════════════════════
// SCROLL TO EMAIL FORM (home "Join Waitlist")
// ══════════════════════════════════════
function initScrollToWaitlist() {
  document.querySelectorAll('[data-scroll-to-waitlist]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.getElementById('waitlist');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });
}

// ══════════════════════════════════════
// IDONATE SCRIPT (Impact page)
// ══════════════════════════════════════
function initIdonate() {
  const container = document.getElementById('idonate-giving-form-container');
  if (!container) return;
  const existing = document.querySelector('script[src*="idonate-giving-form.js"]');
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.src = 'https://apps.idonate.com/idonate-giving-form.js';
  document.body.appendChild(script);
}

// ══════════════════════════════════════
// INIT
// ══════════════════════════════════════
document.addEventListener('DOMContentLoaded', () => {
  fetchCart();
  initHeader();
  initHeroParallax();

// ══════════════════════════════════════
// COMMUNITY SCROLL INIT
// ══════════════════════════════════════
function initCommunityScroll() {
  const marquee = document.querySelector('.community-grid__marquee');
  const items   = document.querySelectorAll('.community-grid__item');
  if (!marquee || items.length < 3) return;

  requestAnimationFrame(() => {
    const vw  = window.innerWidth;
    const gap = 12;

    if (vw < 768) {
      // Mobile: center the 3rd item (first video) on screen
      const itemWidth  = vw - 80; // matches CSS calc(100vw - 80px)
      const itemIndex  = 2;
      const itemCenter = itemIndex * (itemWidth + gap) + itemWidth / 2;
      marquee.scrollLeft = itemCenter - vw / 2;
    } else {
      // Desktop: scroll so the first 4 videos (indexes 2–5) fill the viewport
      const itemWidth = vw * 0.25;       // matches CSS width: 25vw
      const itemIndex = 2;
      marquee.scrollLeft = itemIndex * (itemWidth + gap);
    }
  });
}

// ══════════════════════════════════════
// COMMUNITY LIGHTBOX
// ══════════════════════════════════════
function initCommunityLightbox() {
  const lightbox  = document.getElementById('community-lightbox');
  if (!lightbox) return;

  const backdrop  = lightbox.querySelector('.community-lightbox__backdrop');
  const closeBtn  = lightbox.querySelector('.community-lightbox__close');
  const mediaWrap = lightbox.querySelector('.community-lightbox__media');

  function openLightbox(type, src) {
    mediaWrap.innerHTML = '';
    if (type === 'video') {
      const vid = document.createElement('video');
      vid.src = src;
      vid.controls = true;
      vid.autoplay = true;
      vid.playsInline = true;
      mediaWrap.appendChild(vid);
    } else {
      const img = document.createElement('img');
      img.src = src;
      img.alt = 'FORTA Community';
      mediaWrap.appendChild(img);
    }
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    mediaWrap.innerHTML = '';
  }

  document.querySelectorAll('.community-grid__item').forEach((item) => {
    item.addEventListener('click', () => {
      openLightbox(item.dataset.mediaType, item.dataset.mediaSrc);
    });
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') openLightbox(item.dataset.mediaType, item.dataset.mediaSrc);
    });
  });

  backdrop.addEventListener('click', closeLightbox);
  closeBtn.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeLightbox();
  });
}
  initProductGallery();
  initVariantSelection();
  initQuantitySelector();
  initProductForm();
  initQuickAddBtns();
  initAccordions();
  initWaitlistForm();
  initScrollToWaitlist();
  initIdonate();

  initCommunityLightbox();
  initCommunityScroll();

  // Cart drawer open/close
  document.getElementById('cart-backdrop')?.addEventListener('click', closeCartDrawer);
  document.getElementById('cart-close-btn')?.addEventListener('click', closeCartDrawer);

  // Mobile menu toggle
  document.getElementById('menu-toggle')?.addEventListener('click', toggleMobileMenu);
  document.getElementById('mobile-menu-backdrop')?.addEventListener('click', closeMobileMenu);

  // All cart toggle buttons
  document.querySelectorAll('[data-open-cart]').forEach((btn) => {
    btn.addEventListener('click', openCartDrawer);
  });
});
